export default __webpack_public_path__ + "static/media/Success.12539204.svg";